var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 254,
    height: 199.975,
    viewBox: "0 0 254 199.975",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6600",
    "data-name": "Rect\\xE1ngulo 6600",
    width: 225.517,
    height: 146.841,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_6602",
    "data-name": "Rect\\xE1ngulo 6602",
    d: "M4.881,0H162.252a4.881,4.881,0,0,1,4.881,4.881V85.647a4.881,4.881,0,0,1-4.881,4.881H4.88A4.88,4.88,0,0,1,0,85.648V4.881A4.881,4.881,0,0,1,4.881,0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8998",
    "data-name": "Trazado 8998",
    d: "M1716.285,555.125a2.47,2.47,0,0,0,.726.159l.241,2.156a1.79,1.79,0,0,0,1.628.741,3.99,3.99,0,0,0,2.055-1.24l-.34-3.035c-1,.6-2.893,1.7-4.31,1.219",
    transform: "translate(-1716.285 -553.906)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -37.332,
    y1: 17.493,
    x2: -37.31,
    y2: 17.493,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e09a77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#efaa88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7b290"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9021",
    "data-name": "Trazado 9021",
    d: "M952.734,985.936l-.274-.01.068.01v2.317a1.762,1.762,0,0,0,1.422,1.032c.715.034,2.611-.716,2.862-2.2v-1.841l-.642-.986a4.9,4.9,0,0,1-3.436,1.682",
    transform: "translate(-952.46 -984.254)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -24.356,
    y1: 7.367,
    x2: -24.33,
    y2: 7.367,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d49f82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5ac8e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9024",
    "data-name": "Trazado 9024",
    d: "M940.786,947.381c1.292,1.164,3.222.772,4.66.113l-.112-.406c.857-.28,1.727-1.151,1.166-1.751-.624-.668-1.113.958-1.808,1.255a17.669,17.669,0,0,0,.646-2l-.857-.341.359-1.266a6.032,6.032,0,0,1-3.655-1.438c-.473,1.042-1.729,4.635-.4,5.833",
    transform: "translate(-940.193 -941.548)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -11.504,
    y1: 4.616,
    x2: -11.492,
    y2: 4.616,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19910",
    "data-name": "Grupo 19910",
    transform: "translate(-849 -322)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6613",
    "data-name": "Rect\\xE1ngulo 6613",
    width: 254,
    height: 199.975,
    rx: 4,
    transform: "translate(849 322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19909",
    "data-name": "Grupo 19909",
    transform: "translate(863 348.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19893",
    "data-name": "Grupo 19893",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19892",
    "data-name": "Grupo 19892",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8969",
    "data-name": "Trazado 8969",
    d: "M33.3,0h163.38a7.212,7.212,0,0,1,7.191,7.191V136.854H26.109V7.193A7.212,7.212,0,0,1,33.3,0",
    transform: "translate(-23.203 -0.002)",
    fill: "#ddefff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8970",
    "data-name": "Trazado 8970",
    d: "M74.4,56.376H240.446a.545.545,0,0,1,.543.543v89.441a.545.545,0,0,1-.543.543H74.4a.545.545,0,0,1-.543-.543V56.919a.545.545,0,0,1,.543-.543",
    transform: "translate(-65.637 -50.102)",
    fill: "#a2cdfc",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19895",
    "data-name": "Grupo 19895",
    transform: "translate(8.219 6.276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19894",
    "data-name": "Grupo 19894",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6601",
    "data-name": "Rect\\xE1ngulo 6601",
    width: 167.133,
    height: 90.528,
    fill: "#a2cdfc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19897",
    "data-name": "Grupo 19897",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19896",
    "data-name": "Grupo 19896",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8971",
    "data-name": "Trazado 8971",
    d: "M1228.547,56.376h13.407a18.851,18.851,0,0,0,25.1,20.633V90.814a32.179,32.179,0,0,1-38.644-31.5c0-.992.047-1.973.135-2.942",
    transform: "translate(-1091.702 -50.102)",
    fill: "#c7e1fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8972",
    "data-name": "Trazado 8972",
    d: "M699.244,321.875a15.717,15.717,0,1,1-15.716,15.717,15.717,15.717,0,0,1,15.716-15.717",
    transform: "translate(-607.458 -286.054)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8973",
    "data-name": "Trazado 8973",
    d: "M771.373,384.655l6.561,3.788,6.561,3.788a1.167,1.167,0,0,1,0,2.022l-6.561,3.788-6.561,3.788a1.167,1.167,0,0,1-1.751-1.011V385.666a1.167,1.167,0,0,1,1.751-1.011",
    transform: "translate(-683.971 -341.705)",
    fill: "#ff973d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8974",
    "data-name": "Trazado 8974",
    d: "M808.547,779.929h68.216a.95.95,0,1,1,0,1.9H808.547a.95.95,0,1,1,0-1.9",
    transform: "translate(-717.72 -693.131)",
    fill: "#0d458d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8975",
    "data-name": "Trazado 8975",
    d: "M215.706,758.426l2.512,1.451,2.512,1.451a.447.447,0,0,1,0,.774l-2.512,1.45L215.706,765a.447.447,0,0,1-.671-.387v-5.8a.447.447,0,0,1,.671-.387",
    transform: "translate(-191.104 -673.967)",
    fill: "#e0d8cf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8976",
    "data-name": "Trazado 8976",
    d: "M313.062,779.929h83.532a.95.95,0,1,1,0,1.9H313.062a.95.95,0,1,1,0-1.9",
    transform: "translate(-277.377 -693.131)",
    fill: "#ffeddb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8977",
    "data-name": "Trazado 8977",
    d: "M1065.223,775.745a1.821,1.821,0,1,0-1.821-1.821,1.821,1.821,0,0,0,1.821,1.821",
    transform: "translate(-945.057 -686.176)",
    fill: "#e0d8cf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8978",
    "data-name": "Trazado 8978",
    d: "M1071.94,918.445a.413.413,0,0,0-.061,0h-1.2a.323.323,0,0,0,.094-.131l.07-.178a2.417,2.417,0,0,0,.163-.971.319.319,0,0,0-.625-.077l-.128.44a.32.32,0,0,1-.055.107l-.79,1.016-.021.023a1.043,1.043,0,0,0-.245.693v1.623a.209.209,0,0,0,.208.208h2.437a.6.6,0,0,0,.6-.544l.143-1.552a.6.6,0,0,0-.587-.654m-4.252,2.882h1a.163.163,0,0,0,.153-.17v-2.243a.163.163,0,0,0-.153-.17h-1a.163.163,0,0,0-.153.17v2.243a.163.163,0,0,0,.153.17m20.266.457a.4.4,0,0,0,.06,0h1.2a.32.32,0,0,0-.094.13l-.07.178a2.413,2.413,0,0,0-.164.971.319.319,0,0,0,.625.077l.128-.441a.315.315,0,0,1,.055-.107l.79-1.016.021-.022a1.046,1.046,0,0,0,.244-.694v-1.623a.209.209,0,0,0-.209-.208h-2.436a.6.6,0,0,0-.6.544l-.143,1.552a.6.6,0,0,0,.587.654m4.252-2.882h-1a.163.163,0,0,0-.153.17v2.243a.163.163,0,0,0,.153.17h1a.163.163,0,0,0,.153-.17v-2.243a.163.163,0,0,0-.153-.17m-17.581.132h7.4v2.293h-7.4Zm19.837,0h7.4v2.293h-7.4Zm16.923,0h12.153v2.293h-12.153Zm-2.84,1.64a2.917,2.917,0,0,0-2.711,1.234,2.978,2.978,0,0,1,2.726-2.6v-.955l1.686,1.686-1.686,1.686v-1.1Z",
    transform: "translate(-948.729 -814.818)",
    fill: "#cfcfcf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8979",
    "data-name": "Trazado 8979",
    d: "M1265.748,1093.567h-35a1.51,1.51,0,0,0-1.506,1.506v6.707a1.51,1.51,0,0,0,1.506,1.506h35a1.51,1.51,0,0,0,1.506-1.506v-6.707a1.51,1.51,0,0,0-1.506-1.506",
    transform: "translate(-1092.444 -971.865)",
    fill: "#ff6426",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8980",
    "data-name": "Trazado 8980",
    d: "M1327.28,1126.777v.4h-1.907v-2.827h1.863v.4H1325.8v.762h1.324v.406H1325.8v.853Zm-3.3,0a.489.489,0,0,0,.337-.133.449.449,0,0,0,.1-.141.431.431,0,0,0,.036-.176.424.424,0,0,0-.036-.175.452.452,0,0,0-.1-.142.459.459,0,0,0-.15-.1.487.487,0,0,0-.186-.036h-.718v.9Zm-.718-1.259h.7a.4.4,0,0,0,.287-.114.365.365,0,0,0,0-.535.4.4,0,0,0-.286-.114h-.7Zm1.212.158a.828.828,0,0,1,.2.163.9.9,0,0,1,.14.215.786.786,0,0,1,0,.626.774.774,0,0,1-.189.256.968.968,0,0,1-.284.178.949.949,0,0,1-.357.067h-1.144v-2.827h1.122a.793.793,0,0,1,.315.062.838.838,0,0,1,.258.17.811.811,0,0,1,.172.249.739.739,0,0,1,.062.3.554.554,0,0,1-.047.235.863.863,0,0,1-.1.168.652.652,0,0,1-.145.135m-2.31,1.5h-.426v-2.827h.426Zm-2.512-1.526h.7a.375.375,0,0,0,.162-.036.472.472,0,0,0,.227-.238.431.431,0,0,0,.037-.176.424.424,0,0,0-.037-.175.477.477,0,0,0-.094-.141.455.455,0,0,0-.133-.1.378.378,0,0,0-.162-.036h-.7Zm.493.4h-.493v1.122h-.425v-2.827h1.122a.828.828,0,0,1,.332.067.845.845,0,0,1,.271.182.888.888,0,0,1,.182.272.819.819,0,0,1,.068.332.737.737,0,0,1-.1.4.95.95,0,0,1-.217.245.983.983,0,0,1-.313.161l.7,1.166h-.472Zm-3.545-.292a1.121,1.121,0,0,0,.286.756.938.938,0,0,0,.293.22.792.792,0,0,0,.341.079.859.859,0,0,0,.293-.047.744.744,0,0,0,.392-.324.994.994,0,0,0,.1-.234h.449a1.4,1.4,0,0,1-.158.382,1.26,1.26,0,0,1-1.59.5,1.344,1.344,0,0,1-.429-.3,1.509,1.509,0,0,1-.294-.456,1.511,1.511,0,0,1,0-1.129,1.508,1.508,0,0,1,.294-.458,1.335,1.335,0,0,1,.429-.3,1.242,1.242,0,0,1,.514-.11,1.2,1.2,0,0,1,.435.078,1.183,1.183,0,0,1,.358.213,1.313,1.313,0,0,1,.263.314,1.338,1.338,0,0,1,.157.382h-.449a.963.963,0,0,0-.1-.235.754.754,0,0,0-.162-.193.747.747,0,0,0-.221-.129.779.779,0,0,0-.279-.047.8.8,0,0,0-.341.078.929.929,0,0,0-.293.219,1.126,1.126,0,0,0-.286.757m-2.648-.651a.679.679,0,0,1,.067-.295.748.748,0,0,1,.193-.251.951.951,0,0,1,.3-.174,1.084,1.084,0,0,1,.384-.065.991.991,0,0,1,.37.067.865.865,0,0,1,.292.186.85.85,0,0,1,.191.278.865.865,0,0,1,.067.343h-.427a.47.47,0,0,0-.493-.493.657.657,0,0,0-.212.033.48.48,0,0,0-.165.092.438.438,0,0,0-.1.13.329.329,0,0,0-.036.148.263.263,0,0,0,.112.229,1.125,1.125,0,0,0,.279.138q.165.058.361.115a1.576,1.576,0,0,1,.361.153.89.89,0,0,1,.278.253.69.69,0,0,1,.113.413.658.658,0,0,1-.07.294.8.8,0,0,1-.2.251.959.959,0,0,1-.31.176,1.229,1.229,0,0,1-.41.064,1.188,1.188,0,0,1-.405-.064.908.908,0,0,1-.3-.18.746.746,0,0,1-.191-.277.946.946,0,0,1-.064-.354h.425a.481.481,0,0,0,.134.367.574.574,0,0,0,.4.127.644.644,0,0,0,.424-.117.361.361,0,0,0,.137-.287.3.3,0,0,0-.111-.247.954.954,0,0,0-.278-.15c-.112-.041-.232-.08-.362-.118a1.816,1.816,0,0,1-.361-.15.866.866,0,0,1-.279-.24.639.639,0,0,1-.112-.4m-1.234,1.662a.489.489,0,0,0,.186-.036.484.484,0,0,0,.15-.1.449.449,0,0,0,.1-.141.431.431,0,0,0,.036-.176.424.424,0,0,0-.036-.175.451.451,0,0,0-.249-.238.486.486,0,0,0-.186-.036H1312v.9Zm-.718-1.259h.7a.4.4,0,0,0,.287-.114.365.365,0,0,0,0-.535.394.394,0,0,0-.286-.114h-.7Zm1.212.158a.824.824,0,0,1,.2.163.883.883,0,0,1,.139.215.784.784,0,0,1,0,.626.77.77,0,0,1-.189.256.965.965,0,0,1-.284.178.947.947,0,0,1-.357.067h-1.144v-2.827h1.122a.794.794,0,0,1,.315.062.839.839,0,0,1,.257.17.812.812,0,0,1,.172.249.737.737,0,0,1,.062.3.55.55,0,0,1-.047.235.834.834,0,0,1-.1.168.647.647,0,0,1-.144.135m-3.321,1.145a.626.626,0,0,0,.249-.049.606.606,0,0,0,.333-.348.763.763,0,0,0,.047-.276v-1.795h.427v1.795a1.1,1.1,0,0,1-.079.422.987.987,0,0,1-.554.554,1.183,1.183,0,0,1-.844,0,.991.991,0,0,1-.554-.554,1.113,1.113,0,0,1-.079-.422v-1.795h.427v1.795a.768.768,0,0,0,.047.276.613.613,0,0,0,.58.4m-3.411-1.706a.674.674,0,0,1,.067-.295.751.751,0,0,1,.192-.251.957.957,0,0,1,.3-.174,1.083,1.083,0,0,1,.384-.065.989.989,0,0,1,.37.067.852.852,0,0,1,.55.807h-.427a.47.47,0,0,0-.493-.493.657.657,0,0,0-.212.033.474.474,0,0,0-.165.092.439.439,0,0,0-.1.13.329.329,0,0,0-.036.148.263.263,0,0,0,.112.229,1.125,1.125,0,0,0,.279.138q.165.058.361.115a1.584,1.584,0,0,1,.361.153.891.891,0,0,1,.278.253.69.69,0,0,1,.113.413.648.648,0,0,1-.07.294.8.8,0,0,1-.2.251.959.959,0,0,1-.31.176,1.229,1.229,0,0,1-.41.064,1.188,1.188,0,0,1-.405-.064.912.912,0,0,1-.3-.18.754.754,0,0,1-.191-.277.953.953,0,0,1-.064-.354h.425a.481.481,0,0,0,.135.367.574.574,0,0,0,.4.127.643.643,0,0,0,.424-.117.36.36,0,0,0,.137-.287.3.3,0,0,0-.112-.247.951.951,0,0,0-.278-.15c-.112-.041-.232-.08-.362-.118a1.814,1.814,0,0,1-.361-.15.866.866,0,0,1-.278-.24.642.642,0,0,1-.112-.4",
    transform: "translate(-1161.063 -999.204)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6603",
    "data-name": "Rect\\xE1ngulo 6603",
    width: 40.659,
    height: 2.293,
    transform: "translate(9.665 104.217)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_93",
    "data-name": "L\\xEDnea 93",
    x2: 177.761,
    transform: "translate(2.906 116.271)",
    fill: "none",
    stroke: "#cfcfcf",
    strokeWidth: 2.835
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6604",
    "data-name": "Rect\\xE1ngulo 6604",
    width: 68.086,
    height: 2.293,
    transform: "translate(9.665 109.176)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8981",
    "data-name": "Trazado 8981",
    d: "M84.177,1090.129a5.242,5.242,0,1,1-5.242,5.242,5.242,5.242,0,0,1,5.242-5.242",
    transform: "translate(-70.15 -968.809)",
    fill: "#cfd3ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6605",
    "data-name": "Rect\\xE1ngulo 6605",
    width: 15.101,
    height: 1.793,
    transform: "translate(22.93 123.726)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6606",
    "data-name": "Rect\\xE1ngulo 6606",
    width: 25.288,
    height: 1.793,
    transform: "translate(22.93 127.605)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8982",
    "data-name": "Trazado 8982",
    d: "M0,1184.462a7.076,7.076,0,0,1,.086-1.1,2.2,2.2,0,0,1,.883-.192,1.5,1.5,0,0,1,.163.405c-.324.17-.738.228-.942.494a.963.963,0,0,0-.19.4",
    transform: "translate(0 -1051.481)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8983",
    "data-name": "Trazado 8983",
    d: "M1519.075,584.046c.664.685,3.114,2.957,4.734,4.446-.653.438-1.665,1.01-2.534,1.5-1.312-1.707-2.831-3.725-3.556-4.877-2.5-.893-3.5-2.381-3.057-3.461.242-.584.883-.777,1.874.015a11.778,11.778,0,0,1,1.25,1.218c.012-.043-.268-1.215.074-1.344.5-.187,1.3,1.641,1.217,2.5",
    transform: "translate(-1346.003 -516.472)",
    fill: "#e6a586",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8984",
    "data-name": "Trazado 8984",
    d: "M1553.61,622.525a27.106,27.106,0,0,1-6.878-8.379,16.041,16.041,0,0,1,2.231-1.4,89.553,89.553,0,0,0,7.473,6.123c1.464,1.024,4.034,3.771,3.079,5.124-1.123,1.589-4.833-.655-5.9-1.471",
    transform: "translate(-1374.594 -544.557)",
    fill: "#87b3f1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8985",
    "data-name": "Trazado 8985",
    d: "M1641.4,1140.47l-.486,3.867c-.033.571-.019,2.141.008,4.121.874.751,2.267.546,2.444-.068s.71-6.9.71-6.9Z",
    transform: "translate(-1458.28 -1013.548)",
    fill: "#e5ac8e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8986",
    "data-name": "Trazado 8986",
    d: "M1601.744,1200.466c-.53.056-2.517.16-2.713.176s-.589.287-.711.3a6.01,6.01,0,0,1-1.685-.288c-.214-.049-3.513-.1-3.536-.16a.624.624,0,0,1,.317-.605c.153-.067.82-.292,1.607-.6s1.6-.662,1.984-.853c.237-.12.374-.283.577-.4h0a7.984,7.984,0,0,1,.988-.757c.1.016.824.481.824.6a1.682,1.682,0,0,1-.217.441h0a.9.9,0,0,0,.557.047c.612-.163.664-.87,1.008-.9s1,.782,1,3",
    transform: "translate(-1415.798 -1064.034)",
    fill: "#0c3563",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8987",
    "data-name": "Trazado 8987",
    d: "M1601.795,1225.937l.015.015a1.654,1.654,0,0,1,.116.548,10.943,10.943,0,0,1-3.85.337c-2.466-.065-4.531-.148-4.908-.876h0c.1.064,3.322.11,3.533.158a6.011,6.011,0,0,0,1.684.288c.122-.008.515-.279.711-.3s2.147-.118,2.7-.174",
    transform: "translate(-1415.864 -1089.503)",
    fill: "#a2cdfc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8988",
    "data-name": "Trazado 8988",
    d: "M1631.059,815.934c.05,3.741,1.547,7.707,1.464,8.092-.127.586-.8.112-1.027,1.449-.135.791.371,2,.367,2.741,0,.45-.717.1-.705.573a23.3,23.3,0,0,1-.016,4c-.135.124-.525-.089-.849.02-.339.114-.294.359-.66.4a8.49,8.49,0,0,0-3.528.158c-.788-7.883-1.982-15.77-1.143-23.689.718-6.777,2.453-13.055,3.537-19.68,1.5-.992,2.766-.132,4.768-.069a22.3,22.3,0,0,0,3.181-.214c2.3,7.9-2.6,13.46-4.125,18.925a20.769,20.769,0,0,0-1.262,7.3",
    transform: "translate(-1443.865 -701.654)",
    fill: "#0d458d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8989",
    "data-name": "Trazado 8989",
    d: "M1932.405,1027.527l3.772.98c.562.106,2.121.3,4.088.523.857-.77.834-2.177.247-2.433s-6.747-1.592-6.747-1.592Z",
    transform: "translate(-1717.349 -910.933)",
    fill: "#e5ac8e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8990",
    "data-name": "Trazado 8990",
    d: "M1991.9,1032.862c-.013.532-.166,2.517-.175,2.713s.208.622.2.743a5.986,5.986,0,0,1-.5,1.633c-.076.206-.546,3.472-.614,3.486a.625.625,0,0,1-.559-.393c-.047-.161-.184-.851-.384-1.671s-.45-1.676-.591-2.078c-.088-.25-.233-.407-.322-.624h0a7.954,7.954,0,0,1-.623-1.077c.03-.1.583-.756.7-.741a1.687,1.687,0,0,1,.409.272h0a.9.9,0,0,0,.118-.546c-.083-.628-.777-.771-.759-1.115s.9-.889,3.1-.6",
    transform: "translate(-1767.053 -917.845)",
    fill: "#0c3563",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8991",
    "data-name": "Trazado 8991",
    d: "M1693.5,485.394a4.015,4.015,0,0,1,.668-5.669,6.491,6.491,0,0,1,5.925-.88c2.412.9,2.906,4.133,4.724,4.9s3.888-.931,7.37.279c2.94,1.022,3.41,5.376,4.482,5.962,1.729.946,3.122,1.138,3.878,2.75a6.245,6.245,0,0,1-1.083,6.6,7.8,7.8,0,0,1-9.428,1.2c-2.9-1.639-3.223-4.214-3.966-4.655s-2.865-.093-4.334-1.377-1.057-3.538-3.308-3.992l-1.669-4.176Z",
    transform: "translate(-1504.251 -425.242)",
    fill: "#281616",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8992",
    "data-name": "Trazado 8992",
    d: "M2011.729,1033.058l.017-.013a1.653,1.653,0,0,1,.558-.044,10.942,10.942,0,0,1-.162,3.861c-.382,2.437-.731,4.474-1.5,4.755h0c.077-.093.536-3.28.612-3.483a6.007,6.007,0,0,0,.5-1.634c.007-.122-.21-.547-.2-.743s.159-2.145.175-2.7",
    transform: "translate(-1786.878 -918.026)",
    fill: "#a2cdfc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8993",
    "data-name": "Trazado 8993",
    d: "M1626.665,605.44c.555,1.611,2.085,3.424,3.437,2.909,2.73-2.347,4.454-6.855,5.284-9.512.309-1.952-.145-3.308-1.028-3.875-3.642-2.341-5.422,8.37-7.693,10.479",
    transform: "translate(-1445.634 -528.453)",
    fill: "#87b3f1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8994",
    "data-name": "Trazado 8994",
    d: "M1668.862,580.525a10.086,10.086,0,0,0-3.718,3.176,6.623,6.623,0,0,0-.041,3.861s2.676-.437,2.8-.556,1.2-1.229,1.2-1.757a12.58,12.58,0,0,1,.306-2.075Z",
    transform: "translate(-1479.573 -515.919)",
    fill: "#dfdfe6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8995",
    "data-name": "Trazado 8995",
    d: "M1710.6,783.386c3.013-1.176,6.656-2.036,8.817.152,1.475,5.515-.775,15.881,2.2,19.137,1.938,2.122,6.092,1.578,10.237,1.89.609.046,1.608.994,1.977,1.208,1.268.686,2.208.236,3.075.565a4.288,4.288,0,0,1,1.772,1.571c.2.319,1.557-.514,1.71,0a11.475,11.475,0,0,1-1.1,4.951,172.427,172.427,0,0,0-19.118-2.679,11.057,11.057,0,0,1-5.823-3.206c-3.368-3.9-4.027-18.973-3.744-23.592",
    transform: "translate(-1520.172 -695.137)",
    fill: "#0d458d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8996",
    "data-name": "Trazado 8996",
    d: "M1671.217,577.336c2.521,2.37-1.826,9.96-1.821,13.167.007,4.4,2.066,9.333,2.013,10.683-4.5.9-11.038-1.976-16.092-1.071,1.074-4.05,2.677-7.556,2.884-10.033.562-6.729-2.454-7.24-.357-11.407,1.277-2.538,3.756-3.094,6.246-3.059a14.828,14.828,0,0,1,7.127,1.72",
    transform: "translate(-1471.097 -511.555)",
    fill: "#87b3f1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8997",
    "data-name": "Trazado 8997",
    d: "M1701.9,511.731a2.467,2.467,0,0,1-.726-.159,3.247,3.247,0,0,1-1.78-2.742,9.68,9.68,0,0,1-.111-1.076,9.191,9.191,0,0,1,3.495-2.855,4.6,4.6,0,0,0,2.382,3.69.854.854,0,0,1,1.177-.565c.483.251.931,1.435-1.313,2.688l.317,2.83a2.275,2.275,0,0,1-1.587.955,1.789,1.789,0,0,1-1.628-.74Z",
    transform: "translate(-1510.173 -448.709)",
    fill: "#f7b290",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19899",
    "data-name": "Grupo 19899",
    transform: "translate(191.005 61.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19898",
    "data-name": "Grupo 19898",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6608",
    "data-name": "Rect\\xE1ngulo 6608",
    width: 5.11,
    height: 4.884,
    transform: "translate(-0.486 0.054) rotate(-6.394)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19901",
    "data-name": "Grupo 19901",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19900",
    "data-name": "Grupo 19900",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8999",
    "data-name": "Trazado 8999",
    d: "M1589.125,616.8h6.838a.988.988,0,0,1,.883,1.064v.049h-7.354Z",
    transform: "translate(-1412.272 -548.156)",
    fill: "#469df0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9000",
    "data-name": "Trazado 9000",
    d: "M1420.048,518.647l2.642,6.645,1.7,4.278.443,1.113H1408.1l-4.732-12.036Z",
    transform: "translate(-1247.189 -460.927)",
    fill: "#469df0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9001",
    "data-name": "Trazado 9001",
    d: "M1575.872,616.181c.852.428,3.914,1.766,5.934,2.638-.472.628-1.239,1.5-1.9,2.255-1.8-1.179-3.9-2.584-4.965-3.432-1.028.375-3.585-.586-4.3-1.5-.53-.682,2-.085,3.219-.278,0-.044-.629-1.157.174-1.446.122-.044.211.515.777.885a3.6,3.6,0,0,1,1.053.883",
    transform: "translate(-1395.787 -546.034)",
    fill: "#e6a586",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9002",
    "data-name": "Trazado 9002",
    d: "M1634.42,638.382c-1.736,3.033-4.3,2.589-7.2,1.716a28.537,28.537,0,0,1-10.371-5.726c-.118-.107,1.311-1.609,1.645-2.054,1.713.739,10.221,4.405,12.188,3.858.564-.113,3.447,1.449,3.742,2.206",
    transform: "translate(-1436.901 -561.948)",
    fill: "#a2cdfc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9003",
    "data-name": "Trazado 9003",
    d: "M1731.6,598.572c.448,1.643,2.488,2.909,3.871,2.482a35.718,35.718,0,0,0,4.779-7.664c.436-1.927-.124-3.432-.968-4.055-3.482-2.574-7.1,7.581-7.682,9.237",
    transform: "translate(-1538.889 -523.379)",
    fill: "#a2cdfc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9004",
    "data-name": "Trazado 9004",
    d: "M915.434,1008.594c-.9,9.311-3.149,14.021.71,23.834-2.594.631-13.738,2.965-15.673,1.514,4.814-13.9-.2-19.055,1.132-25.966,4.031-2.65,10.691-.9,13.831.619",
    transform: "translate(-800.258 -894.582)",
    fill: "#fdce3d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9005",
    "data-name": "Trazado 9005",
    d: "M827.779,1069.9c.631.632,3.163,3.674,6.927.313s-.716-5.737-.716-5.737l-2.644,3.173-1.6-.9Z",
    transform: "translate(-735.656 -946.012)",
    fill: "#f7b290",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9006",
    "data-name": "Trazado 9006",
    d: "M871.182,1018.9a45.366,45.366,0,0,0-4.941,6.25,38.264,38.264,0,0,0,4.035,3.676,20.27,20.27,0,0,0,3-4.077Z",
    transform: "translate(-769.837 -905.506)",
    fill: "#fdce3d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9007",
    "data-name": "Trazado 9007",
    d: "M714.738,987.491c1.423,3.033,7.106,7.579,9.945,10.355,3.779,3.695,4.709-.318,4.109-1.062a15.3,15.3,0,0,0-1.7-1.74c-4.5-3.758-11.258-7.671-11.5-8.3.6-2.186-.649-2.679-.58-1.08a2.287,2.287,0,0,0-2.317-1.6c-.426.166-.474,1.063,2.043,3.421",
    transform: "translate(-633.181 -874.518)",
    fill: "#f7b290",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9008",
    "data-name": "Trazado 9008",
    d: "M844.332,1118.125c.893-.279,11.93-3.549,13.471-4.133.332-.447.495-3.44.662-4.575a37.915,37.915,0,0,0,4.531.255c-.28,2.042-1.344,6.79-2.14,7.519-2.893,2.646-12.507,2.149-16.45,2.533-.527.388-3.146,1.926-4.95-.382-.707-1.105,2.909-1.677,3.744-1.085-.811-.753-.842-1.4-.563-1.678.251-.159.833.265,1.7,1.547",
    transform: "translate(-745.952 -985.951)",
    fill: "#f7b290",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9009",
    "data-name": "Trazado 9009",
    d: "M1029.729,1273.074a4.983,4.983,0,0,1,2.225,1.4c.548.605,2.359-2.712,2.359-2.712l-.169-.3a17.891,17.891,0,0,0-3.483-1.523Z",
    transform: "translate(-915.131 -1128.609)",
    fill: "#f7bcaa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9010",
    "data-name": "Trazado 9010",
    d: "M1049.166,1274.164a7.818,7.818,0,0,1-.666,2.37,8.351,8.351,0,0,1-1.709,2.42c-.309.153-1.56-1.055-1.636-1.21s.826-3.2,1.365-3.6,2.608-.262,2.646.016",
    transform: "translate(-928.836 -1132.126)",
    fill: "#0d458d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9011",
    "data-name": "Trazado 9011",
    d: "M794.7,1217.539c8.509,6.446,10.484,6.925,15.828,7.072s11.974-3.083,17.189-6.593l-1.52-2.217-7.81-.732-9.176,2.733-8.4-.635Z",
    transform: "translate(-706.255 -1079.844)",
    fill: "#0c3563",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9012",
    "data-name": "Trazado 9012",
    d: "M806.592,1192.911l-1.885,4.14a161.81,161.81,0,0,1-18.145-3.921c-2.652-.774-12.085-4.109-9.363-8.464,1.89-3.025,11.234-.508,29.393,8.245",
    transform: "translate(-690.271 -1051.737)",
    fill: "#0c3563",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9013",
    "data-name": "Trazado 9013",
    d: "M809.218,1268.136l-2.794-.049c-.528.119-2.807,1.16-4.6,1.7-.455.992.1,2.206.7,2.207s6.207-1.462,6.207-1.462Z",
    transform: "translate(-712.439 -1126.962)",
    fill: "#e5ac8e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9014",
    "data-name": "Trazado 9014",
    d: "M778.322,1270.054l1.4,4.879a5.978,5.978,0,0,0,1.818-.656c.458-.317.838-.637.779-.865-.118-.461-.885.049-1.035-.623s.455-.592.229-1.48a7.048,7.048,0,0,0-2.009-1.236,1.5,1.5,0,0,0-1.185-.021",
    transform: "translate(-691.703 -1128.613)",
    fill: "#0d458d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9015",
    "data-name": "Trazado 9015",
    d: "M778.322,1270.1l1.4,4.879a3.273,3.273,0,0,0,.627-.15L778.8,1270a2.179,2.179,0,0,0-.48.1",
    transform: "translate(-691.703 -1128.66)",
    fill: "#343c7d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9016",
    "data-name": "Trazado 9016",
    d: "M818.638,1190.51l1.84,3.705c3.2-.522,14.687-2.226,21.992-4.255,2.85-.792,11.962-5.052,9.147-9.123-2.029-2.934-14.675,1.228-32.979,9.673",
    transform: "translate(-727.532 -1048.591)",
    fill: "#0d458d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9017",
    "data-name": "Trazado 9017",
    d: "M964.018,1199.648h-5.456v.946h5.929v-.473a.474.474,0,0,0-.473-.473",
    transform: "translate(-851.884 -1066.14)",
    fill: "#f99746",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9018",
    "data-name": "Trazado 9018",
    d: "M798.74,1122.406l-3.753-10.738H777.91l3.675,10.738Z",
    transform: "translate(-691.337 -987.951)",
    fill: "#f99746",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9019",
    "data-name": "Trazado 9019",
    d: "M1007.66,1025.885c.54,2.059-.114,6.725-.591,8.246l-.1.006a27.56,27.56,0,0,1-5.345-.362,28.1,28.1,0,0,1,.27-4.987c.111-.525.651-5.789,2.421-5.957,1.273-.121,2.807,1,3.346,3.054",
    transform: "translate(-890.15 -908.993)",
    fill: "#fdce3d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9020",
    "data-name": "Trazado 9020",
    d: "M852.258,1145.78a1.419,1.419,0,1,1-1.419,1.419,1.419,1.419,0,0,1,1.419-1.419",
    transform: "translate(-756.15 -1018.267)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19903",
    "data-name": "Grupo 19903",
    transform: "translate(105.999 109.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19902",
    "data-name": "Grupo 19902",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6610",
    "data-name": "Rect\\xE1ngulo 6610",
    width: 4.352,
    height: 5.064,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19905",
    "data-name": "Grupo 19905",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19904",
    "data-name": "Grupo 19904",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9022",
    "data-name": "Trazado 9022",
    d: "M953.073,990.087a2.835,2.835,0,0,0,2.8-1.161c-.08.906-.938,2.052-2.8,2.078Z",
    transform: "translate(-847.006 -878.869)",
    fill: "#bd8a6f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9023",
    "data-name": "Trazado 9023",
    d: "M941.6,906.453a17.749,17.749,0,0,0,.646-2l-.857-.341.359-1.266a5.563,5.563,0,0,1-4.283-2.172c-2.479-3.553,1.888-5.87,2.827-3a5.31,5.31,0,0,1,4.421,1.273,3.4,3.4,0,0,1,1.048,3.236c.706.156,1.475,1.357,1.056,2.979a4.383,4.383,0,0,1-4.207,3.124l-.369-1.338c.857-.28,1.727-1.151,1.167-1.752-.624-.668-1.113.959-1.808,1.255",
    transform: "translate(-832.466 -796.626)",
    fill: "#2d357d",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19907",
    "data-name": "Grupo 19907",
    transform: "translate(104.634 104.786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19906",
    "data-name": "Grupo 19906",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6612",
    "data-name": "Rect\\xE1ngulo 6612",
    width: 8.972,
    height: 9.367,
    transform: "matrix(0.303, -0.953, 0.953, 0.303, -2.757, 6.354)",
    fill: "url(#linear-gradient-3)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVideo);
export default __webpack_public_path__ + "static/media/logo_video.3d14a2c70c15c36787b3390c53706a16.svg";
export { ForwardRef as ReactComponent };